<template>
    <section>
        <div class="sp-title">结算清单</div>
        <div class="sp-nav"><span class="sp-nav-item">水运业务</span><span class="sp-nav-item-sple">/</span><span
                class="sp-nav-item">配载管理</span><span class="sp-nav-item-sple">/</span><span
                class="sp-nav-item">配载单详情</span><span class="sp-nav-item-sple">/</span><span
                class="sp-nav-item">结算清单</span></div>

        <div class="sp-bottom-search sp-bottom-search-margin">
            <div class="sp-bottom-search-left" style="line-height: 40px;">
                <div class="block">
                    <span class="demonstration" style="margin-right: 20px;font-size: 0.9rem;">客户:</span>
                    <el-tag style="margin-right: 10px;cursor: pointer;" :type="selectCustomer==item.id?'success':'info'"
                            v-for="(item,index) in customergoodsList" :key="index" @click="shaixuankehu(item.id)">
                        {{getCustomerName(item.customerSecondlevelId)}}
                    </el-tag>
                </div>
            </div>

            <div class="sp-bottom-search-right" style="text-align: left">
                <!--<el-button type="primary" round @click="selectByParam(selectCustomer)">搜索</el-button>-->
                <el-button type="primary" round @click="mode()">添加结算清单</el-button>
            </div>

        </div>
        <div class="sp-content-bg">
            <!--下部面板-->
            <div class="sp-bottom-bg" style="padding: 20px;padding-top: 0px;">
                <div class="sp-panel-data-title sp-panel-data-title2" style="margin: 20px 0;line-height: 20px">
                    <div style="margin-right: 1%;"><img style="width: 20px" src="../assets/img/cus.png"/></div>
                    <div style="margin-right: 3%;color: #5992F5;font-size: 1.2rem;overflow: hidden;white-space: nowrap;width: 13%;">
                        {{customerGoods.customerSecondlevelId==null?'--':getCustomerName(customerGoods.customerSecondlevelId)}}
                    </div>
                    <div style="margin-right: 3%;line-height: 20px;">
                        {{customerGoods.transportTime==null?'--':shipTimeFmt(customerGoods.transportTime)}}
                    </div>
                    <div style="line-height: 20px;margin-right: 3%;">{{customerGoods.goodsType==null?'--':goodsTypeFmt(customerGoods.goodsType)}}</div>
                    <div style="margin-right: 3%;line-height: 20px;">装货码头：{{fmtWharfName(customerGoods.loadWharf)}}</div>
                    <div style="margin-right: 3%;line-height: 20px;">卸货码头：{{fmtWharfName(customerGoods.unloadWharf)}}</div>
                    <div style="margin-right: 3%;line-height: 20px;">{{customerGoods.tonnage==null?'--':customerGoods.tonnage}}吨</div>
                    <div style="margin-right: 3%;line-height: 20px;">{{customerGoods.freightRate==null?'--':customerGoods.freightRate}}元/吨</div>
                    <div style="line-height: 20px;">{{customerGoods.goodsSource==null?'--':goodsSourceFmt(customerGoods.goodsSource)}}</div>
                </div>
                <template>
                    <el-table
                            :data="tableData"
                            stripe
                            style="width: 100%">
                        <el-table-column
                                align="center"
                                :formatter="publicFmt"
                                prop="goodsWeight"
                                label="货物吨位"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                :formatter="publicFmt"
                                prop="endArriveWharf"
                                label="终到码头"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                :formatter="publicFmt"
                                prop="incomePrice"
                                label="运价"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                :formatter="publicFmt"
                                prop="payShipPrice"
                                label="船价"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                :formatter="publicFmt"
                                prop="goodsCostCompany"
                                label="货物费用公司"
                                width="140">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                :formatter="publicFmt"
                                prop="goodsCostPrice"
                                label="货物费用价格"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                :formatter="publicFmt"
                                prop="shipCostTitle"
                                label="船上费用项目"
                                width="140">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                :formatter="publicFmt"
                                prop="shipCostPrice"
                                label="船上费用金额"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                fixed="right"
                                label="操作"
                                width="140"
                        >
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="mobf(scope.row)">编辑</el-button>
                                <el-button type="text" size="small" @click="delect(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :page-size="pageSize"
                            :current-page="pageNo"
                            @current-change="eventPage"
                            style="text-align: right;padding: 10px 0px;background-color: #fff"
                    >
                    </el-pagination>
                </template>
            </div>
        </div>

        <el-dialog
                class="xuanxiang"
                title="添加货物详情"
                :visible.sync="showAdd"
                width="700px"
                :before-close="handleClose">
            <!--<div style="overflow-y: scroll;height: 300px;">-->
            <div style="height: 225px;">
                <el-form
                        :rules="userrules"
                        ref="addDetail"
                        label-position="left"
                        label-width="80px"
                        :model="customerGoodsDetail">
                    <el-tabs tab-position="left">
                        <el-tab-pane label="基本信息">
                            <div class="sp-add-block">
                                <div class="sp-add-block-row">
<!--                                    <el-form-item class="sp_add_left" label="货种" prop="goodsType">-->
<!--                                        <el-input placeholder="输入货种" v-model="customerGoodsDetail.goodsType"></el-input>-->
<!--                                    </el-form-item>-->
                                    <el-form-item class="sp_add_left" label="货物重量" prop="goodsWeight">
                                        <el-input placeholder="输入货物重量" v-model="customerGoodsDetail.goodsWeight" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item class="sp_add_right" label="终到码头">
                                        <el-input placeholder="输入卸货码头" v-model="customerGoodsDetail.endArriveWharf"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="sp-add-block-row">
<!--                                    <el-form-item class="sp_add_left" label="装货码头">-->
<!--                                        <el-input placeholder="输入装货码头" v-model="customerGoodsDetail.loadWharf"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item class="sp_add_right" label="终到码头">-->
<!--                                        <el-input placeholder="输入卸货码头" v-model="customerGoodsDetail.endArriveWharf"></el-input>-->
<!--                                    </el-form-item>-->
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="运费收入">
                            <div class="sp-add-block">
                                <div class="sp-add-block-title">
                                    <div class="sp-add-block-title-icon"><img class="sp-add-block-title-img" src="../assets/img/income.png"/></div>
                                    <div class="sp-add-block-title-text">运费收入</div>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="运价">
                                        <el-input placeholder="输入运价" v-model="customerGoodsDetail.incomePrice" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item class="sp_add_right" label="发票">
                                        <el-input placeholder="输入发票" v-model="customerGoodsDetail.incomeBill"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="合同公司">
                                        <el-input placeholder="输入合同公司" v-model="customerGoodsDetail.incomeCompany"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="运费支出">
                            <div class="sp-add-block">
                                <div class="sp-add-block-title">
                                    <div class="sp-add-block-title-icon"><img class="sp-add-block-title-img" src="../assets/img/pay.png"/></div>
                                    <div class="sp-add-block-title-text">运费支出</div>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="船价">
                                        <el-input placeholder="输入船价" v-model="customerGoodsDetail.payShipPrice" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item class="sp_add_right" label="发票">
                                        <el-input placeholder="输入发票" v-model="customerGoodsDetail.payBill"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="合同公司">
                                        <el-input placeholder="输入合同公司" v-model="customerGoodsDetail.payCompany"></el-input>
                                    </el-form-item>
                                    <el-form-item class="sp_add_right" label="进票价格">
                                        <el-input placeholder="输入进票价格" v-model="customerGoodsDetail.payTicketPrice" type="number"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="进项发票">
                                        <el-input placeholder="输入进项发票" v-model="customerGoodsDetail.payIncomeBill"></el-input>
                                    </el-form-item>
                                    <el-form-item class="sp_add_right" label="成本">
                                        <el-input placeholder="输入成本" v-model="customerGoodsDetail.payVirtualCost" type="number"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="货物费用">
                            <div class="sp-add-block">
                                <div class="sp-add-block-title">
                                    <div class="sp-add-block-title-icon"><img class="sp-add-block-title-img" src="../assets/img/goodscost.png"/></div>
                                    <div class="sp-add-block-title-text">货物费用</div>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="费用公司">
                                        <el-input placeholder="输入费用公司" v-model="customerGoodsDetail.goodsCostCompany"></el-input>
                                    </el-form-item>

                                    <el-form-item class="sp_add_right" label="价格">
                                        <el-input placeholder="输入价格" v-model="customerGoodsDetail.goodsCostPrice"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="发票">
                                        <el-input placeholder="输入发票" v-model="customerGoodsDetail.goodsCostBill"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="船上及其他费用">
                            <div class="sp-add-block">
                                <div class="sp-add-block-title">
                                    <div class="sp-add-block-title-icon"><img class="sp-add-block-title-img" src="../assets/img/shipcost.png"/></div>
                                    <div class="sp-add-block-title-text">船上费用</div>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="发生项目">
                                        <el-input placeholder="输入发生项目" v-model="customerGoodsDetail.shipCostTitle"></el-input>
                                    </el-form-item>

                                    <el-form-item class="sp_add_right" label="金额">
                                        <el-input placeholder="输入金额" v-model="customerGoodsDetail.shipCostPrice" type="number"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="承担方">
                                        <el-input placeholder="输入承担方" v-model="customerGoodsDetail.shipCostBear"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="sp-add-block">
                                <div class="sp-add-block-title">
                                    <div class="sp-add-block-title-icon"><img class="sp-add-block-title-img" src="../assets/img/other.png"/></div>
                                    <div class="sp-add-block-title-text">其他</div>
                                </div>
                                <div class="sp-add-block-row">
                                    <el-form-item class="sp_add_left" label="价格">
                                        <el-input placeholder="输入价格" v-model="customerGoodsDetail.otherPrice" type="number"></el-input>
                                    </el-form-item>

                                    <el-form-item class="sp_add_right" label="名称">
                                        <el-input placeholder="输入名称" v-model="customerGoodsDetail.otherTitle"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveDetail">确 定</el-button>
            </span>
        </el-dialog>
    </section>
</template>

<script>
    import {getDictionaryList} from '../api/sysdictionary'
    import {getCusNameById} from "../api/customermanage";
    import {getCustomerGoodsById, saveGoodsDetail,updateCustomerGoodsDetail} from "../api/customergoods";
    import {getAllCustomerGoods} from "../api/stowage";

    import {ERR_OK} from "../jslib/config";
    import {fmtDictionary} from "../jslib/util"
    import {getAllSysWharf} from "../api/sysWharf";

    export default {
        data() {
            return {
                showAdd:false,
                tableData:[],
                total: 0,
                pageNo: 1,
                pageSize: 5,
                customerList: [],
                goodsId:null,
                stowageId:null,
                customerGoods:{},
                dictionaryLists: {},
                customergoodsList:[],
                selectCustomer:null,
                customerGoodsDetail:{},
                userrules:{
                    // goodsType: [
                    //     { required: true, message: '请输入货物种类', trigger: 'blur' }
                    // ],
                    goodsWeight: [
                        { required: true, message: '请输入货物重量', trigger: 'blur' },
                    ],
                    name: [
                        { required: true, message: '请输入用户名称', trigger: 'blur' }
                    ],
                },
                wharfList:[],
            };
        },
        created() {
            this.goodsId = this.$route.query.goodsId;
            this.stowageId = this.$route.query.stowageId;
            this.selectCustomer = this.goodsId


            var that = this
            const loading = this.$loading({
                lock: true,
                text: '加载菜单中，请稍后！',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            getDictionaryList("goods_type,goods_source").then(res => {
                if (res != undefined && res.resultCode === ERR_OK) {
                    this.dictionaryLists = res.map
                }
                getAllCustomerGoods(that.stowageId).then(res =>{
                    if (res != undefined && res.resultCode === ERR_OK) {
                        that.customergoodsList = res.list
                        var cusList = ''
                        for(var i =0;i<that.customergoodsList.length;i++){
                            var tmp = that.customergoodsList[i]
                            cusList += (tmp.customerSecondlevelId+",")
                        }
                        that.getCusNameById(cusList)
                        that.getCustomerGoods(1);
                        loading.close();
                    }
                })
            })


            getAllSysWharf().then(res=>{
                if (res!=undefined&&res.resultCode === ERR_OK) {
                    this.wharfList = res.list
                }
            })
        },
        mounted() {
        },
        methods: {
            mobf(obj){
                this.customerGoodsDetail = Object.assign({}, obj);
                this.showAdd = true;
            },
            mode(){
                this.showAdd = true
            },
            tosave(){
                if(this.customerGoodsDetail.id!=undefined&&
                    this.customerGoodsDetail.id!=null&&
                    this.customerGoodsDetail.id!=''
                ){//修改操作
                    this.customerGoodsDetail.createDate = null
                    this.customerGoodsDetail.updateDate = null
                    updateCustomerGoodsDetail(this.customerGoodsDetail).then(res=>{
                        if (res!=undefined&&res.resultCode === ERR_OK) {
                            this.handleClose()
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                        }
                    })
                }else {//新增操作
                    this.customerGoodsDetail["customerGoodsId"] = this.goodsId
                    this.customerGoodsDetail["stowageId"] = this.stowageId
                    saveGoodsDetail(this.customerGoodsDetail).then(res => {
                        if (res != undefined && res.resultCode === ERR_OK) {
                            this.handleClose()
                        }
                    })
                }
            },
            saveDetail(){
                this.$refs['addDetail'].validate((valid) => {
                    if (valid) {
                        this.tosave();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            handleClose(){
                this.showAdd = false;
                this.getCustomerGoods(1)
            },
            shaixuankehu(id){
                this.selectCustomer = id
                this.goodsId = id
                this.getCustomerGoods(1)
            },
            getCustomerGoods(pageNo){
                if(this.pageNo != pageNo){
                    this.pageNo = pageNo
                }
                const loading = this.$loading({
                    lock: true,
                    text: '加载菜单中，请稍后！',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                getCustomerGoodsById(pageNo,this.pageSize,this.goodsId,this.stowageId).then(res =>{
                    if (res != undefined && res.resultCode === ERR_OK) {
                        this.customerGoods = res.data
                        this.tableData = res.page.records
                        console.info( this.customerGoods)
                        console.info(this.tableData)
                        loading.close();
                    }
                })
            },
            getCusNameById(cusList){
                getCusNameById(cusList).then(res =>{
                    if (res != undefined && res.resultCode === ERR_OK) {
                        this.customerList = res.list
                    }
                })
            },
            shipTimeFmt(item) {
                return item.substring(0, 10)
            },
            onQuery() {

            },


            eventPage(e) {
                this.getCustomerGoods(e)
            },
            publicFmt(row, column, cellValue, index) {
                var v = '--'
                if (cellValue != undefined && cellValue != null && cellValue != '') {
                    v = cellValue
                }
                return v
            },
            goods_typeFmt(row, column, cellValue, index) {
                return fmtDictionary(cellValue, this.dictionaryLists['goods_type']);
            },
            goods_sourceFmt(row, column, cellValue, index) {
                return fmtDictionary(cellValue, this.dictionaryLists['goods_source']);
            },
            goodsSourceFmt(item) {
                return fmtDictionary(item, this.dictionaryLists['goods_source']);
            },
            goodsTypeFmt(item) {
                return fmtDictionary(item, this.dictionaryLists['goods_type']);
            },
            getCustomerName(cusName) {
                var v = '--'
                if (cusName != undefined && cusName != null && cusName != '') {
                    for (var i = 0; i < this.customerList.length; i++) {
                        var t = this.customerList[i];
                        if (t.id == cusName) {
                            v = t.abbreviationName
                        }
                    }
                }
                return v
            },
            fmtWharfName(cellValue){

                var v = '--'
                for(var i=0;i<this.wharfList.length;i++){
                    var tmp = this.wharfList[i]
                    if(cellValue == tmp.id){
                        v =  tmp.wharf
                        break;
                    }
                }
                return v

            },
        },
        computed: {},
        components: {}
    }
</script>

<style scoped>
    .sp-panel-data-title2{
        width: 88%;
        display: flex;
        line-height: 15px;
        text-align: left;
    }
    .query-form{
        text-align: left;
        padding-top: 10px;
    }
    .sp_add_left{
        width: 45%;
        margin-right: 5%;
    }
    .sp_add_right{
        width: 45%;
    }
    .xuanxiang >>> .el-dialog__body{
        padding: 10px 0px !important;
    }
    .sp-add-block{

    }
    .sp-add-block-row{
        display: flex;
    }
    .sp-add-block-title{
        display: flex;
        width: 100%;
        line-height: 20px;
        margin-bottom: 10px;
    }
    .sp-add-block-title-icon{
        margin-right: 10px;
    }
    .sp-add-block-title-img{
        width: 20px;
    }
    .sp-add-block-title-text{
        font-size: 16px;
        font-weight: 500;
    }
    .sp-content-bg-2{
        margin-top: 0px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border-top-right-radius: 0px;
        border-top-left-radius: 0px;
    }
    .xuanxiang >>> .el-dialog__body{
        padding: 10px 0px !important;
    }
    .sp_add_right >>> .el-form-item__label{
        text-align: right !important;
    }
    .sp_add_left >>> .el-form-item__label{
        text-align: right !important;
    }
</style>
